'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.controller("ticketDocumentEditionPopinController", function ($scope) {
  var originalDocument = $scope.document;
  $scope.document = angular.copy(originalDocument);
  $scope.saveAndClose = function () {
    _.extend(originalDocument, $scope.document);
    $scope.$close(originalDocument);
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ticket/ticketDocumentEditionPopin.js
// module id = 2895
// module chunks = 13